export enum Shop {
    CSC = 'CSC',
    WEBSHOP = 'WEBSHOP',
    WPP = 'WPP',
}
